/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Layout_RenamedInputs */

const vi_sidebar_layout_renamed = /** @type {(inputs: Sidebar_Layout_RenamedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(đã đổi tên)`)
};

/**

* @param {Sidebar_Layout_RenamedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sidebar_layout_renamed = /** @type {((inputs?: Sidebar_Layout_RenamedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Layout_RenamedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sidebar_layout_renamed(inputs)
});